<template>
    <div class="ras-home">
        <div class="ras-home__content">
            <h1 class="ras-home__logo">
                <img
                    alt="Jetflix Vacactions by My Baggage"
                    src="images/svgs/jetflix.svg"
                />
                <span class="u-visually-hidden"
                    >Jetflix Vacations by My Baggage</span
                >
            </h1>
            <h2 class="ras-heading ras-home__heading">
                Let Jetflix Choose Your Next Vacation
            </h2>
            <TextBlock :paras="intro" :centered="true" />
            <router-link class="ras-button" :to="{ path: 'person' }"
                >Take the Quiz</router-link
            >
        </div>
        <div class="ras-home__video">
            <video autoplay="true" loop="true" muted playsinline>
                <source
                    src="video/my-baggage-jetflix-locations-home-page-hero-video-square.mp4"
                    type="video/mp4"
                />
            </video>
        </div>
    </div>
</template>

<script>
import TextBlock from '@/components/Common/TextBlock.vue'
export default {
    name: 'Home',
    components: {
        TextBlock
    },
    data: () => ({
        intro: [
            '<strong>Looking to book your next vacation?</strong><br/>Decide your next vacation based on your latest binge.',
            'Find the best destination for you with this quiz on your viewing preferences, gender and age.'
        ]
    })
}
</script>

<style lang="scss">
.ras-main {
    .ras-home {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;

        @media (min-width: map_get($breakpoints, lg)) {
            flex-direction: row;
        }

        &__content {
            max-width: 450px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 50px 36px 0;

            @media (min-width: map_get($breakpoints, lg)) {
                margin: 0 0 0 10vw;
                padding: 0;
                height: 100%;
            }
        }

        &__logo {
            max-width: 225px;
            margin-bottom: 50px;

            @media (min-width: map_get($breakpoints, lg)) {
                max-width: 400px;
                margin-bottom: 100px;
            }

            @media (min-width: map_get($breakpoints, lg)) and (max-height: map_get($v-breakpoints, xs)) {
                max-width: 300px;
                margin-bottom: 50px;
            }

            img {
                display: flex;
            }
        }

        &__heading {
            color: $c-primary;
            margin-bottom: 20px;
        }

        &__video {
            height: 100%;
            margin-left: auto;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: linear-gradient(
                    90deg,
                    $c-home-background 0%,
                    transparent 20%
                );
            }

            video {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
